import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

export class FeaturesI18N {
  private static readonly bundles = new Map<string, Map<string, string>>();
  private static locale: string = '';

  static addBundle(locale: string, bundle: Map<string, string>) {
    FeaturesI18N.bundles.set(locale, bundle);
  }

  static addString(locale: string, key: string, value: string) {
    const bundle = FeaturesI18N.bundles.get(locale);
    if (bundle) {
      bundle.set(key, value);
    }
  }

  static getLocale(): string {
    return FeaturesI18N.locale;
  }

  static setLocale(locale: string) {
    FeaturesI18N.locale = locale;
  }

  static getString(key: string) {
    const bundle = FeaturesI18N.bundles.get(FeaturesI18N.locale);
    if (!bundle) {
      return '[L(' + FeaturesI18N.locale + ')]';
    }
    const val = bundle.get(key);
    if (!val) {
      return '[K(' + key + ')]';
    }
    return val;
  }
}

@Injectable()
export class PaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = FeaturesI18N.getString('paginator.page.size');
  override nextPageLabel = FeaturesI18N.getString('paginator.page.next');
  override previousPageLabel = FeaturesI18N.getString('paginator.page.prev');
  override firstPageLabel = FeaturesI18N.getString('paginator.page.first');
  override lastPageLabel = FeaturesI18N.getString('paginator.page.last');
  override getRangeLabel = function (page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return (
        FeaturesI18N.getString('paginator.page.curr1') +
        ' ' +
        length +
        '; ' +
        FeaturesI18N.getString('paginator.page.curr2') +
        ' ' +
        FeaturesI18N.getString('paginator.page.curr3')
      );
    }
    return (
      FeaturesI18N.getString('paginator.page.curr1') +
      ' ' +
      length +
      '; ' +
      FeaturesI18N.getString('paginator.page.curr2') +
      ' ' +
      (page + 1) +
      ' ' +
      FeaturesI18N.getString('paginator.page.curr4') +
      ' ' +
      Math.floor((length + pageSize - 1) / pageSize)
    );
  };
}
